import * as React from 'react'
import { memo, useMemo } from 'react'

import { CommunityIcon } from '@/components/atoms/Logo/CommunityIcon'
import { Avatar, AvatarProps } from '@/components/ui/avatar'
import { useColorModeValue } from '@/components/ui/color-mode'
import { CircleLogoFragment } from '@/graphql/api/generated'

type Props = {
  circle: CircleLogoFragment
  alt?: string
} & AvatarProps

export const CircleLogo = memo(({ circle, ...otherProps }: Props) => {
  const borderColor = useColorModeValue('#eee', '#444')
  const bgColor = useColorModeValue('white', 'gray.700')

  const logoUrl = useMemo(
    () => circle.logo?.contentUrl,
    [circle.logo?.contentUrl]
  )

  const icon = useMemo(() => <CommunityIcon width={30} height={30} />, [])

  return (
    <Avatar
      src={logoUrl}
      icon={icon}
      border={`1px solid ${borderColor}`}
      boxShadow="lg"
      bg={bgColor}
      name={circle.name}
      title={circle.name}
      {...otherProps}
    />
  )
})
